import React from 'react';
import {
  Card,
  CardBody,
  VStack,
  HStack,
  Text,
  Badge,
  Wrap,
  WrapItem,
  useColorModeValue
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface WordCollectionProps {
  selectedWords: string[];
}

const WordCollection: React.FC<WordCollectionProps> = ({ selectedWords }) => {
  const { t } = useTranslation();

  const cardBg = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.800', 'white');

  if (selectedWords.length === 0) {
    return null;
  }

  return (
    <Card bg={cardBg} shadow="lg" borderRadius="2xl">
      <CardBody p={6}>
        <VStack spacing={4}>
          <HStack justify="space-between" w="full">
            <Text fontSize="lg" fontWeight="bold" color={textColor}>
              {t('onboarding.vocabulary.yourCollection')}
            </Text>
            <Badge colorScheme="blue" variant="solid" borderRadius="full" px={3} py={1}>
              {selectedWords.length} {t('common.words')}
            </Badge>
          </HStack>

          <Wrap spacing={2}>
            {selectedWords.map((word, index) => (
              <WrapItem key={index}>
                <Badge
                  colorScheme="blue"
                  variant="outline"
                  borderRadius="full"
                  px={3}
                  py={1}
                  fontSize="sm"
                >
                  {word}
                </Badge>
              </WrapItem>
            ))}
          </Wrap>
        </VStack>
      </CardBody>
    </Card>
  );
};

export default WordCollection;